export default __webpack_public_path__ + "static/media/slide_13.4374cd46.jpg";